import { EditorContent, useEditor } from '@tiptap/react';
import { ANNOUNCEMENT_BODY_EXTENSIONS } from '@/app/modules/announcements/core/_consts';
import '@/app/modules/announcements/components/AnnouncementRichText.scss';

type AnnouncementBodyProps = {
  body: string;
};

// O texto passa pelo esquema do editor, que descarta script e link perigoso: por isso não há innerHTML.
const AnnouncementBody = ({ body }: AnnouncementBodyProps) => {
  const editor = useEditor({ extensions: ANNOUNCEMENT_BODY_EXTENSIONS, content: body, editable: false }, [body]);
  return <EditorContent className="announcement-rich-text" editor={editor} />;
};

export default AnnouncementBody;
